import axios from 'axios';
import { API } from '@/utils/api';

const PORTAL_API_BASE = `${API}/portal`;

const withPortalHeaders = (token, config = {}) => {
  const headers = { ...(config.headers || {}) };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return { ...config, headers };
};

export const portalApi = {
  async exchangeInvite(payload) {
    const response = await axios.post(`${PORTAL_API_BASE}/session`, payload);
    return response.data;
  },
  async listInvoices(token, params = {}) {
    const response = await axios.get(`${PORTAL_API_BASE}/invoices`, {
      ...withPortalHeaders(token),
      params,
    });
    return response.data;
  },
  async fetchPaymentLinks(invoiceId, token) {
    const response = await axios.get(
      `${PORTAL_API_BASE}/invoices/${invoiceId}/payment-link`,
      withPortalHeaders(token)
    );
    return response.data;
  },
  async uploadDocument({ file, description }, token) {
    const formData = new FormData();
    formData.append('file', file);
    if (description) {
      formData.append('description', description);
    }
    const response = await axios.post(
      `${PORTAL_API_BASE}/documents`,
      formData,
      withPortalHeaders(token, { headers: { 'Content-Type': 'multipart/form-data' } })
    );
    return response.data;
  },
};
